module.exports = __webpack_public_path__ + "img/msg.6b14a05a.jpg";